import { Container, ContainerProps } from '@mui/material';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import { useLayoutConfiguration } from 'src/common/hooks/useLayoutConfiguration';
import { useScrollHandler } from 'src/common/hooks/useScrollHandler';

interface LayoutContentContainerProps extends Omit<ContainerProps, 'onScroll'> {
  children: React.ReactNode;
  horizontalPadding?: {
    xs?: number;
    md?: number;
  };
}

const getContainerHeight = (isShowingBottomNav: boolean) => {
  return isShowingBottomNav ? '81vh' : '88vh';
};

export default function LayoutContentContainer({
  children,
  horizontalPadding = { xs: 1, md: 1 },
  ...containerProps
}: LayoutContentContainerProps) {
  const { isMobile, statusBar } = useAppUI();
  const { showBottomNav } = useLayoutConfiguration();
  const handleScroll = useScrollHandler(isMobile);

  const shouldHandleKeyboard = isMobile;
  const containerHeight = shouldHandleKeyboard
    ? getContainerHeight(showBottomNav)
    : undefined;
  const containerOverflow = shouldHandleKeyboard ? 'auto' : undefined;
  const containerMinHeight =
    showBottomNav && !shouldHandleKeyboard ? '100vh' : undefined;
  const containerPaddingBottom = {
    xs: showBottomNav ? 13 : 5,
    md: 5,
  };
  const containerPaddingTop = statusBar?.visible ? 2 : 1;

  return (
    <Container
      onScroll={handleScroll}
      maxWidth="md"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pb: containerPaddingBottom,
        pt: containerPaddingTop,
        px: horizontalPadding,
        minHeight: containerMinHeight,
        maxHeight: containerHeight,
        overflow: containerOverflow,
      }}
      {...containerProps}
    >
      {children}
    </Container>
  );
}
